import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import TextButton from '../../../../../../../atomic/buttons/textButton/TextButton';
import CheckBox from '../../../../../../../atomic/formElements/checkBox/CheckBox';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { TableSelect } from '../../../../../../../atomic/inputs/tableSelect/TableSelect';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const CandleTriggerTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const tacticId =
      tradePlanStore.tradePlans[tradePlanId].setupDetails['CANDLE_TRIGGER']
        ?.tacticId ?? null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;
    const updateTactic = (field, newValue) => {
      updatePlugins(
        'setup',
        { [field]: newValue },
        'CANDLE_TRIGGER',
        tradePlanId,
        null
      );
    };
    if (!tradePlan?.setupDetails['CANDLE_TRIGGER']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              {/* ROW 1 */}
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candle Duration
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={
                      tradePlan.setupDetails['CANDLE_TRIGGER'].candleDuration
                    }
                    updateValue={(newValue) =>
                      updateTactic('candleDuration', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor={colors.black}
                  />
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Time Unit
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <TableSelect
                    color={colors.lightGrey}
                    backgroundColor={colors.black}
                    value={tradePlan.setupDetails['CANDLE_TRIGGER'].timeUnit}
                    onChange={(newValue) => updateTactic('timeUnit', newValue)}
                    options={[
                      { label: 'Minutes', value: 'MINUTES' },
                      { label: 'Days', value: 'DAYS' },
                      { label: 'Weeks', value: 'WEEKS' },
                      { label: 'Months', value: 'MONTHS' },
                    ]}
                  />
                </td>
              </tr>
              {/* ROW 2 */}
              <tr style={{ backgroundColor: colors.grey }}>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candles Back
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={
                      tradePlan.setupDetails['CANDLE_TRIGGER'].candlesBack
                    }
                    updateValue={(newValue) =>
                      updateTactic('candlesBack', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor={colors.grey}
                  />
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Break By
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    $
                  </Body3>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={
                      tradePlan.setupDetails['CANDLE_TRIGGER'].breakBy
                    }
                    updateValue={(newValue) =>
                      updateTactic('breakBy', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor={colors.grey}
                  />
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Check Validation
                  </Body3>
                </td>
                <td>
                  <CheckBox
                    fontSize="10px"
                    margin="auto 5px"
                    checked={
                      tradePlan.setupDetails['CANDLE_TRIGGER'].checkValidation
                    }
                    onChange={(newValue) => {
                      if (
                        newValue !== 0 &&
                        newValue !==
                          tradePlan.setupDetails['CANDLE_TRIGGER']
                            .checkValidation
                      )
                        updateTactic('checkValidation', newValue);
                    }}
                  />
                </td>

                {softOrder && softOrder?.value.tacticValue.longFailed ? (
                  <td>
                    <TextButton
                      clickHandler={() => updateTactic('activateLong', true)}
                      color={colors.lightGrey}
                      width="100%"
                      fontSize="small"
                      backgroundColor={colors.blue}
                    >
                      Activate Long
                    </TextButton>
                  </td>
                ) : (
                  <td></td>
                )}
                {softOrder && softOrder?.value.tacticValue.shortFailed ? (
                  <td>
                    <TextButton
                      clickHandler={() => updateTactic('activateShort', true)}
                      color={colors.lightGrey}
                      width="100%"
                      fontSize="small"
                      backgroundColor={colors.blue}
                    >
                      Activate Short
                    </TextButton>
                  </td>
                ) : (
                  <td></td>
                )}
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Bounce on Gap Fill
                  </Body3>
                </td>
                <td>
                  <CheckBox
                    fontSize="10px"
                    margin="auto 5px"
                    checked={
                      tradePlan.setupDetails['CANDLE_TRIGGER'].bounceOnGapFill
                    }
                    onChange={(newValue) => {
                      if (
                        newValue !==
                        tradePlan.setupDetails['CANDLE_TRIGGER'].bounceOnGapFill
                      )
                        updateTactic('bounceOnGapFill', newValue);
                    }}
                  />
                </td>
                <td>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Gap Type
                  </Body3>
                </td>
                <td>
                  <TableSelect
                    value={tradePlan.setupDetails['CANDLE_TRIGGER'].gapType}
                    options={[
                      { label: 'High/Low', value: 'highLow' },
                      { label: 'Open/Close', value: 'openClose' },
                    ]}
                    onChange={newValue => updateTactic('gapType', newValue)}
                    backgroundColor="inherit"
                    color={colors.lightGrey}
                    disabled={!tradePlan.setupDetails['CANDLE_TRIGGER'].bounceOnGapFill}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

CandleTriggerTacticPanel.tabsRole = 'TabPanel';
